function changeServerModule({ input, output, services }) {
  services.Http
    .get(`/modules/change/server/${input.name}`)
    .then(output.success)
    .catch(output.error)
}

changeServerModule.async = true
export default changeServerModule



// WEBPACK FOOTER //
// ./src/modules/user/actions/changeServerModule.js